import React, { useRef, useState } from "react";
import loginImage from "../../assets/img/bjpLoginImage.png";
import { Link, useNavigate } from "react-router-dom";
import { Form, Input, Button } from "antd";
import { EyeInvisibleOutlined, EyeOutlined } from "@ant-design/icons";
import {user} from "../../utlis/dummy";

const Login = () => {
  const navigate = useNavigate();
  const [showPassword, setShowPassword] = useState(false);
  const [loginError, setLoginError] = useState("");
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };
const primaryColor="#E96E16"
const textColor="#D9986A"
  const handleSubmit = async (loginData) => {
    setLoginError("");
    console.log("loginData", loginData);
    console.log("user",user);
    try {
      const logUser = user.filter((data) =>  data.email === loginData?.email);

     if(logUser.length==1){
      console.log("loguser",logUser);
const passCheck=logUser[0]?.password===loginData?.password
if(passCheck){
  if(logUser[0]?.type==="admin"){

    navigate('/dashboard');
  }
  else{
    navigate('/admin/dashboard');
  }
}
else{
  setLoginError("Password is wrong");
}
     }
     else{
      setLoginError("User Not Exist");
     }
    } catch (error) {
      console.log(error);
      setLoginError("try error");
    }
  };

  return (
    <>
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <div className="loginbox">
              <div className="login-left">
                <img className="img-fluid" src={loginImage} alt="Logo" />
              </div>
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1 className="mb-4 text-2xl">Welcome to Metasoft</h1>
                  <h1 className="my-3">Login</h1>

                  <Form className="relative" onFinish={handleSubmit}>
                    <Form.Item
                      name="email"
                      rules={[
                        {
                          type: "email",
                          message: "The input is not valid E-mail!",
                        },
                        {
                          required: true,
                          message: "Please input your E-mail!",
                        },
                      ]}
                    >
                      <Input className="h-10" placeholder="Official Email" />
                    </Form.Item>

                    <Form.Item
                      name="password"
                      rules={[
                        {
                          required: true,
                          message: "Please input your password!",
                        },
                      ]}
                    >
                      <Input
                        type={showPassword ? "text" : "password"}
                        className="h-10"
                        placeholder="Password*"
                      />
                    </Form.Item>
                    <span
                      className="absolute top-[75px] right-5 cursor-pointer"
                      onClick={togglePasswordVisibility}
                    >
                      {showPassword ? (
                        <EyeOutlined
                          style={{ fontSize: "16px", color: "black" }}
                        />
                      ) : (
                        <EyeInvisibleOutlined
                          style={{ fontSize: "16px", color: "black" }}
                        />
                      )}
                    </span>

                    {loginError ? (
                      <span className="text-red-500 mx-2">{loginError}</span>
                    ) : (
                      ""
                    )}
                    <div className="mb-2 flex  justify-end  hover:text-sky-900 hover:underline" style={{color:textColor}} >
                      <Link href="/forgot-password">
                        <Link
                          onClick={() => {
                            setOtpCmp(true);
                          }}
                        >
                          Forgot Password?
                        </Link>
                      </Link>
                    </div>
                    <div className="form-group mb-0">
                      <Button
                        className="w-full h-10 rounded-md text-white"
                        htmlType="submit"
                        style={{backgroundColor:primaryColor}}
                      >
                        LogIn
                      </Button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
